import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const SETTINGS_ROUTES: RouteObject[] = [
  {
    path: 'settings',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'users',
        lazy: async () => {
          const UsersPage = lazy(() => import('@/pages/users/UsersPage.tsx'))
          return { element: <UsersPage /> }
        }
      },
      {
        path: 'categories',
        lazy: async () => {
          const CategoryPage = lazy(
            () => import('@/pages/settings/categories/CategoryPage.tsx')
          )
          return { element: <CategoryPage /> }
        }
      },
      {
        path: 'brands',
        lazy: async () => {
          const BrandsPage = lazy(
            () => import('@/pages/settings/brands/BrandsPage.tsx')
          )
          return { element: <BrandsPage /> }
        }
      },
      {
        path: 'localizations',
        lazy: async () => {
          const LocalizationPage = lazy(
            () => import('@/pages/settings/localization/LocalizationPage.tsx')
          )
          return { element: <LocalizationPage /> }
        }
      },
      {
        path: 'tasas',
        lazy: async () => {
          const TasaPage = lazy(
            () => import('@/pages/settings/tasa/TasaPage.tsx')
          )
          return { element: <TasaPage /> }
        }
      },
      {
        path: 'roles',
        lazy: async () => {
          const RolesPage = lazy(
            () => import('@/pages/settings/roles/RolesPage.tsx')
          )
          return { element: <RolesPage /> }
        }
      },
      {
        path: 'imports',
        lazy: async () => {
          const ImportPage = lazy(
            () => import('@/pages/settings/import/ImportPage.tsx')
          )
          return { element: <ImportPage /> }
        }
      },
      {
        path: 'promotions',
        lazy: async () => {
          const PromotionsPage = lazy(
            () => import('@/pages/settings/promotions/PromotionsPage.tsx')
          )
          return { element: <PromotionsPage /> }
        }
      },
      {
        path: 'paymentMethods',
        lazy: async () => {
          const PaymentMethodsPage = lazy(
            () =>
              import('@/pages/settings/paymentMethods/PaymentMethodsPage.tsx')
          )
          return { element: <PaymentMethodsPage /> }
        }
      },
      {
        path: 'banks',
        lazy: async () => {
          const BanksPage = lazy(
            () => import('@/pages/settings/banks/BanksPage.tsx')
          )
          return { element: <BanksPage /> }
        }
      },
      {
        path: 'pushNotifications',
        lazy: async () => {
          const PushNotificationsPage = lazy(
            () =>
              import(
                '@/pages/settings/pushNotifications/PushNotificationsPage.tsx'
              )
          )
          return { element: <PushNotificationsPage /> }
        }
      },
      {
        path: 'levels',
        lazy: async () => {
          const LevelsPage = lazy(
            () => import('@/pages/settings/levels/LevelsPage.tsx')
          )
          return { element: <LevelsPage /> }
        }
      },
      {
        path: 'publicity',
        lazy: async () => {
          const PublicityPage = lazy(
            () => import('@/pages/settings/publicity/PublicityPage.tsx')
          )
          return { element: <PublicityPage /> }
        }
      }
    ]
  }
]

export default SETTINGS_ROUTES
